<!--
  班级获奖
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="card-body">

            <div class="divSeachBox">
              <div class="divItemBox">
                <el-select v-model="semesterId" placeholder="请选择学期" @change="onSemester">
                  <el-option v-for="item in optSemester" :key="item.semesterId" :label="item.name" :value="item.semesterId">
                  </el-option>
                </el-select>
              </div>
              <div class="divItemBox">
                <el-select v-model="weekIndex" placeholder="请选择校历周" clearable @change="onWeek">
                  <el-option v-for="item in optWeek" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="divItemBox">
                <el-select v-model="collegeId" placeholder="请选择专业部" @change="onCollege">
                  <el-option v-for="item in optCollege" :key="item.collegeId" :label="item.name" :value="item.collegeId">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              各班活动情况
            </h3>
          </div>
          <div class="card-body">
            <comBar ref="myChart_Activity" comID="myChart_Activity" :key="random" :comxAxisData="ActivityData.xAxisData" :comSeries="ActivityData.series" v-if="ActivityData.xAxisData.length > 0"></comBar>
            <el-empty :image-size="200" description="暂无数据" name="3" v-else></el-empty>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              各班获奖情况
            </h3>
          </div>
          <div class="card-body">
            <comBar ref="myChart_award" comID="myChart_award" :key="random" :comxAxisData="PrizeData.xAxisData" :comSeries="PrizeData.series" v-if="PrizeData.xAxisData.length > 0"></comBar>
            <el-empty :image-size="200" description="暂无数据" name="3" v-else></el-empty>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              各班处分情况
            </h3>
          </div>
          <div class="card-body">
            <comBar ref="myChart_punish" comID="myChart_punish" :key="random" :comxAxisData="PunishData.xAxisData" :comSeries="PunishData.series" v-if="PunishData.xAxisData.length > 0"></comBar>
            <el-empty :image-size="200" description="暂无数据" name="3" v-else></el-empty>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              各班宿舍扣分情况
            </h3>
          </div>
          <div class="card-body">
            <comBar ref="myChart_dormitory" comID="myChart_dormitory" :key="random" :comxAxisData="DormitoryLogData.xAxisData" :comSeries="DormitoryLogData.series" v-if="DormitoryLogData.xAxisData.length > 0"></comBar>
            <el-empty :image-size="200" description="暂无数据" name="3" v-else></el-empty>
          </div>
        </el-card>
      </el-col>
      <el-col :md="24">
        <el-card class="box-card">
          <div slot="header" class="card-header">
            <h3 class="card-title">
              各班学生请假情况
            </h3>
          </div>
          <div class="card-body">
            <comBar ref="myChart_leave" comID="myChart_leave" :key="random" :comxAxisData="LeaveData.xAxisData" :comSeries="LeaveData.series" v-if="LeaveData.xAxisData.length > 0"></comBar>
            <el-empty :image-size="200" description="暂无数据" name="3" v-else></el-empty>
          </div>
        </el-card>
      </el-col>
    </el-row>



  </div>
</template>

<script>
  import '@/assets/css/Admin.css';
  import comBar from '@/components/Report/statistics/barTotal.vue';
  export default {
    components: {
      comBar
    },
    data() {
      return {
        fullscreenLoading: false,
        leavePercType: '0',
        leaveNumType: '1',
        semesterId:null,
        weekIndex:null,
        collegeId:null,
        optSemester:[],
        optWeek:[],
        optCollege:[],
        items: [],
        random: 0,
        ActivityData: {
          xAxisData: [],
          series: []
        },
        PrizeData: {
          xAxisData: [],
          series: []
        },
        PunishData: {
          xAxisData: [],
          series: []
        },
        DormitoryLogData: {
          xAxisData: [],
          series: []
        },
        LeaveData: {
          xAxisData: [],
          series: []
        }
      };
    },
    created() {
      let that = this;
      ajaxGet(that, "/api/admin/semester", null, function(res) {
        ajaxGet(that, '/api/admin/college', null, function(resCollege) {
          that.optCollege = resCollege;
          that.optSemester = res;
          that.optSemester.forEach(element => {
            if(element.isCurrent) {
              that.semesterId = element.semesterId;
              that.onSemester(element.semesterId);
            }
          })
          if(that.optCollege && that.optCollege.length > 0) {
            that.collegeId = that.optCollege[0].collegeId;
          }
          
          GetClassStatiStics(that);
        })
      });
      
    },
    methods: {
      onCollege(val) {
        let that = this;
        GetClassStatiStics(that);
      },
      onWeek(val) {
        let that = this;
        GetClassStatiStics(that);
      },
      onSemester(val) {
        let that = this;
        that.optWeek = [];
        that.weekIndex = null;
        if(val) {
          ajaxGet(that, "/api/admin/semesterday/week/" + val, null, function(r) {
            var list = [];
            for (var i = 0; i < r; i++) {
              var newWeek = {
                value: i + 1,
                label: '第' + (i + 1) + '周'
              }
              list.push(newWeek);
            }
            that.optWeek = list;
            GetClassStatiStics(that);
          })
        }
      },
    },
  };

  function GetClassStatiStics(that) {
    let data = {
      SemesterId: that.semesterId,
      weekIndex: that.weekIndex,
      collegeId: that.collegeId
    }
    ajaxGet(that, "/api/admin/statistics/classstatistics", data, function(r) {
      that.items = r;
      that.ActivityData.series = [];
      that.PrizeData.series = [];
      that.PunishData.series = [];
      that.DormitoryLogData.series = [];
      that.LeaveData.series = [];
      if(that.items.length > 0) {
        that.items[0].chartData.forEach(char => {
          that.ActivityData.series.push({
            name: char.name,
            type: 'bar',
            stack: 'total',
            data: []
          })
          that.PrizeData.series.push({
            name: char.name,
            type: 'bar',
            stack: 'total',
            data: []
          })
          that.PunishData.series.push({
            name: char.name,
            type: 'bar',
            stack: 'total',
            data: []
          })
          that.DormitoryLogData.series.push({
            name: char.name,
            type: 'bar',
            stack: 'total',
            data: []
          })
          that.LeaveData.series.push({
            name: char.name,
            type: 'bar',
            stack: 'total',
            data: []
          })
        })
      }

      that.ActivityData.xAxisData = [];
      that.PrizeData.xAxisData = [];
      that.PunishData.xAxisData = [];
      that.DormitoryLogData.xAxisData = [];
      that.LeaveData.xAxisData = [];
      that.items.forEach(item => {
        that.ActivityData.xAxisData.push(item.className);
        that.PrizeData.xAxisData.push(item.className);
        that.PunishData.xAxisData.push(item.className);
        that.DormitoryLogData.xAxisData.push(item.className);
        that.LeaveData.xAxisData.push(item.className);

        item.chartData.forEach(char => {
          that.ActivityData.series.forEach(ser => {
            if(char.name == ser.name) {
              ser.data.push(char.activity);
            }
          })
          that.PrizeData.series.forEach(ser => {
            if(char.name == ser.name) {
              ser.data.push(char.prize);
            }
          })
          that.PunishData.series.forEach(ser => {
            if(char.name == ser.name) {
              ser.data.push(char.punish);
            }
          })
          that.DormitoryLogData.series.forEach(ser => {
            if(char.name == ser.name) {
              ser.data.push(char.dormitoryLog);
            }
          })
          that.LeaveData.series.forEach(ser => {
            if(char.name == ser.name) {
              ser.data.push(char.leave);
            }
          })
        })
      })

      var random = Math.floor(Math.random() * (100000 - 1 + 1)) + 10000;
      that.random += random;
    })
  }
</script>

<style scoped="scoped" lang="less">
  .divSeachBox{
    width: 700px;
    margin: 0 auto;
    display: flex;
    .divItemBox{
      margin-left: 5px;
      margin-right: 5px;
    }
  }

  .cardTypeLable {
    border: 2px solid #FFFFFF;

    &:hover {
      cursor: pointer;
      border: 2px solid #3364FF;
    }

    .typeLabelBox {
      height: 80px;

      .rightBox {
        float: left;
      }

      .leftBox {
        text-align: center;
        width: 100px;
        height: 80px;
        float: left;
      }

      .numberBox {
        color: #323D56;
        font-family: 'OswaldLight';
        font-size: 34px;
        letter-spacing: 1px;
        font-weight: bold;

        .spUnit {
          font-size: 18px;
          padding-left: 5px;
        }
      }

      .iconBox {
        background-color: #EEEEEE;
        color: #000000;
        width: 70px;
        height: 70px;
        border-radius: 50%;

        .icon {
          font-size: 34px;
        }
      }

      .typeName {
        color: #ACB2C6;
        letter-spacing: 1px;
      }

      .labelColor_1 {
        background-color: #E5FBFA;
        color: #17DCCD;
      }

      .labelColor_2 {
        background-color: #EAEFFF;
        color: #3364FF;
      }

      .labelColor_3 {
        background-color: #FFF5F8;
        color: #FFA1C0;
      }

      .labelColor_4 {
        background-color: #FFF8EB;
        color: #FFBC20;
      }

      .labelColor_5 {
        background-color: #E9FBE5;
        color: #3DDC18;
      }

      .labelColor_6 {
        background-color: #FFEAF4;
        color: #FF3368;
      }

      .labelColor_7 {
        background-color: #EAFFFE;
        color: #33C1FF;
      }


    }
  }








  label {
    margin-bottom: 0;
  }
</style>
